import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideZoneChangeDetection
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  NoPreloading,
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
  withPreloading,
} from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ContentService, GlobalsService, RequestService, KreadorTitleStrategy, requestInterceptor } from './core';

export const appConfig: ApplicationConfig = {
  providers: [
    GlobalsService, RequestService,
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([requestInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withPreloading(NoPreloading),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      })
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: () => {
        // Initialize the title strategy - it will listen to route changes automatically
        return () => new KreadorTitleStrategy();
      },
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (cs: ContentService) => () => cs.preload(),
      deps: [ContentService],
      multi: true,
    },
  ]
};
